import React from 'react';
import ContextMenu from 'Common/Components/ContextMenu';
import { Separator } from 'Common/Components/ContextMenu/styled';
import { useDispatch, useSelector } from 'react-redux';
import { selectContextMenuXPos, selectContextMenuYPos, selectSelected, selectShowContextMenu } from 'store/Contextualization/AssetDetail/selectors';
import { showContextMenu } from 'store/Contextualization/AssetDetail/actions';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { WithPermission } from 'Common/Components/WithPermission';
import { selectUserRole, selectIsReadOnly } from 'store/Faraday/selectors';
import {
  AddNewEvidence, Delete, Edit, Filter, Severity, Status, CopyLink, CopyApiLink, SaveAsTemplate
} from './components';
import ApplyTemplate from './components/ApplyTemplate';
import { Tags } from './components/Tags';
import { AddComment } from './components/AddComment';

const VulnsContextMenu = () => {
  const role = useSelector(selectUserRole);
  const dispatch = useDispatch();
  const displayContextMenu = useSelector(selectShowContextMenu);
  const xPos = useSelector(selectContextMenuXPos);
  const yPos = useSelector(selectContextMenuYPos);
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const isBulk = vulnsSelected.length > 1;
  const areVulnsSelected = vulnsSelected.length > 0;
  const readOnly = useSelector(selectIsReadOnly);
  const showLine = !(role === 'client' || role === 'asset_owner');

  if (readOnly || !displayContextMenu || !areVulnsSelected) return null;
  return (
    <ContextMenu
      show={ displayContextMenu }
      xPos={ xPos }
      yPos={ yPos }
      displayFunction={ (show, x, y) => dispatch(showContextMenu(show, x, y)) }
    >
      <Filter />
      <Separator show={ !isBulk && areVulnsSelected } />
      <CopyLink />
      <CopyApiLink />
      <WithPermission permission={ FEATURE_VULNS } type={ PERMISSION_TYPES.UPDATE }>
        <Edit />
      </WithPermission>
      <Tags />
      <WithPermission permission={ FEATURE_VULNS } type={ PERMISSION_TYPES.UPDATE }>
        <Severity />
      </WithPermission>
      <Status />
      <AddComment />
      <WithPermission permission={ FEATURE_VULNS } type={ PERMISSION_TYPES.UPDATE }>
        <AddNewEvidence />
        <Separator show />
        <SaveAsTemplate />
        <ApplyTemplate />
      </WithPermission>
      <WithPermission permission={ FEATURE_VULNS } type={ PERMISSION_TYPES.UPDATE }>
        <Separator show={ showLine } />
        <Delete />
      </WithPermission>
    </ContextMenu>
  );
};

export default VulnsContextMenu;
